import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { Code, Link, Text, Title } from '@/components/typography';

type Props = {
  children: string;
};

const Markdown = ({ children }: Props) => {
  return (
    <div className="markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children, href }) => (
            <Link
              className="text-[length:inherit]! leading-[inherit]! tracking-[inherit]!"
              variant="body1"
              to={href}
            >
              {children}
            </Link>
          ),
          body: ({ children }) => <Text variant="body1">{children}</Text>,
          code: ({ children, className }) => {
            const match = /language-(\w+)/.exec(className || '');
            const lang = className != null ? match?.[1] || 'text' : undefined;
            return <Code language={lang === 'markup' ? 'html' : lang}>{children}</Code>;
          },
          h1: ({ children }) => <Title level={1}>{children}</Title>,
          h2: ({ children }) => <Title level={2}>{children}</Title>,
          h3: ({ children }) => <Title level={3}>{children}</Title>,
          h4: ({ children }) => <Title level={4}>{children}</Title>,
          h5: ({ children }) => <Title level={5}>{children}</Title>,
          h6: ({ children }) => <Title level={6}>{children}</Title>,
          i: ({ children }) => <span className="italic">{children}</span>,
          link: ({ children, href }) => (
            <Link
              className="text-[length:inherit]! leading-[inherit]! tracking-[inherit]!"
              variant="body1"
              to={href}
            >
              {children}
            </Link>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
